// Import bonds from static data file
import { Bonds } from './BondsStaticData.js'

export const fx = {
    "USDUSD": 1.0,
    "USDGBP": 0.789,
    "USDEUR": 0.915,
    "USDBHD": 0.376,
    "USDJPY": 149.52,
    "USDSAR": 3.75,
    "USDQAR": 3.64,
    "USDAED": 3.67,
    "USDOMR": 0.385,
    "USDKWD": 0.307
}
export const TradeData = [
    {   "id": "ABC0001",
        "tradeRef": "LEI 20190522-000000028",
        "trader": "TR0001",
        "productType": "RPO",
        "isin": "XS1405770733",                         
        "cleanPrice": 99.429,
        "entity": "SICO-BH",
        "cpty": "CP0001",
        "repoRate": 6.5,
        "term": "ON",                                
        "start": "2024-06-28",                      
        "end": "2024-06-29",                        
        "days": 1,
        "nominal": 20000000,
        "aip": 100.277,
        "haircut": 15,                                  
        "startCash": 17046342,
        "ccy": "USD",                               
        "cashFx": 1,
        "interest": 2026137.866,
        "endCash": 135722937.866,
        "settlement": "CBB",                       
        "fee": 10,
        "feeCcy": "USD",
        "execMethod": "Pre-arranged Trade",
        "tradeDate": "2024-06-28",
        "tradeTime": "13:05:25",
        "status": "confirmed"
    },


    {   "id": "ABC0002",
        "tradeRef": "LEI 20190522-000000029",
        "trader": "TR0002",
        "productType": "RPO",
        "isin": "US05674RAK05",                         
        "cleanPrice": 99.429,
        "entity": "SICO-BH",
        "cpty": "CP0001",
        "repoRate": 6.5,
        "term": "ON",                                
        "start": "2024-06-28",                      
        "end": "2024-06-29",                        
        "days": 1,
        "nominal": 20000000,
        "aip": 100.277,
        "haircut": 15,                                  
        "startCash": 17046342,
        "ccy": "USD",                               
        "cashFx": 1,
        "interest": 2026137.866,
        "endCash": 135722937.866,
        "settlement": "CBB",                       
        "fee": 10,
        "feeCcy": "USD",
        "execMethod": "Pre-arranged Trade",
        "tradeDate": "2024-06-28",
        "tradeTime": "13:05:25",
        "status": "unconfirmed"
    }
]

export const Traders = {
    "TR0001": {
        "name": "John Smith"
    }
}

export const Clearing = {
    "CBB": {
        
    },

    "EUREX": {

    },

    "LCH": {

    },

    "BIS": {

    }
}

export const CollateralType = {
    "Cash": {

    }
}

export const Basis = {
    "30-360": {

    }
}

export const Products = {
    "VRPO": {

    },
    
    "STLB": {

    },

    "RRPO": {

    },

    "XRPO": {

    }
}

// Export bonds
export { Bonds }

export const Entities = {
    "ABC": {
        "name": "Absolute Collateral",
        "shortName": "AbsColl",
        "address": "",
        "city": "",
        "postcode": "",
        "country": "",
        "phone": ""
    },

    "SICO-BH": {
        "name": "SICO Bahrain",
        "shortName": "",
        "address": "Bahrain Financial Harbour, Harbour Gate",
        "city": "Manama",
        "postcode": "317",
        "country": "Bahrain",
        "phone": "+973 1700 0000"
    },

    "SICO-LON": {
        "name": "SICO London",
        "shortName": "",
        "address": "20 Fenchurch Street",
        "city": "London",
        "postcode": "EC3M 3BY",
        "country": "United Kingdom",
        "phone": "+44 20 7000 0101"
    },

    "SICO-NY": {
        "name": "SICO New York",
        "shortName": "",
        "address": "375 Park Avenue",
        "city": "New York",
        "postcode": "NY 10152",
        "country": "United States",
        "phone": "+1 212 000 0000"
    },

    "ACUK": {
        "name": "Absolute Collateral UK",
        "shortName": "ACUK",
        "address": "30 St Mary Axe",
        "city": "London",
        "postcode": "EC3A 8BF",
        "country": "United Kingdom",
        "phone": "+44 20 7000 0000"
    },


}

export const Cptys = {
    "CP1001" : {
        "name": "Al Baraka"
    },

    "CP1002" : {
        "name": "Al Salam Bank"
    },

    "CP1003" : {
        "name": "Standard Chartered BH"
    },

}


/**
 * "CUSTOM" : {
        "days": 0,
        "description": "Custom"
    },
 */
export const Terms = {
    
    "CUSTOM" : {
        "days": 0,
        "description" : "Custom",
        "start": 0
    },

    "ON" : {
        "days": 1,
        "description" : "Overnight",
        "start": 0
    },

    "TN": {
        "days": 1,
        "description": "Tomorrow Next",
        "start": 1
    },

    "SN": {
        "days": 1,
        "description": "Spot Next",
        "start": 0
    },

    "S1W": {
        "days": 7,
        "description": "Spot 1 Week",
        "start": 0
    },

    "S1M": {
        "days": 30,
        "description": "Spot 1 Month",
        "start": 0
    },

    "S3M": {
        "days": 91,
        "description": "Spot 3 Months",
        "start": 0
    },

    "S6M": {
        "days": 182,
        "description": "Spot 6 Months",
        "start": 0
    },

    "S12M": {
        "days": 365,
        "description": "Spot 12 Months",
        "start": 0
    },

}

export const Ccys = {
    "USD": {

    },
    "BHD": {

    },
    "GBP": {

    },
    "EUR": {

    },
    "JPY": {

    }
}